export default {
  loader: {
    none: 'No results',
    end: 'No more data'
  },
  menu: {
    login: 'Log in',
    signup: 'Sign up',
    username: 'Username',
    password: 'Password',
    confirmation: 'Confirmation',
    mail: 'Email',
    location: 'Location',
    language: 'Language',
    english: 'English',
    french: 'French',
    birthday: 'Birthday',
    ok: 'OK',
    validate: 'Validate'
  },
  categories: {
    news: 'News',
    reviews: 'Reviews',
    interviews: 'Interviews',
    releases: 'Releases',
    events: 'Events',
    encyclopedia: 'Encyclopedia',
    forums: 'Forums'
  },
  reviews: {
    credits: 'Review by'
  },
  interviews: {
    credits: 'Interview by'
  },
  gigs: {
    title: 'Upcoming event',
    what: 'What?',
    where: 'Where?',
    when: 'When?',
    who: 'Who?',
    price: 'Price'
  },
  liveReports: {
    credits: 'Live report by'
  },
  galleries: {
    credits: 'Gallery by'
  },
  events: {
    gigs: 'Gigs',
    liveReports: 'Live reports',
    photos: 'Photos'
  },
  encyclopedia: {
    styles: 'Styles',
    bands: 'Bands',
    artists: 'Artists',
    albums: 'Albums',
    audios: 'Audios',
    videos: 'Videos',
    labels: 'Labels',
    places: 'Places',
    stats: 'Statistics',
    search: 'Search...',
    info: 'About',
    sheet: 'Description sheet',
    style: 'Style',
    band: 'Band',
    country: 'Country',
    region: 'Region',
    city: 'City',
    date: 'Date',
    status: 'Status',
    website: 'Website'
  },
  style: {
    bands: 'Famous bands',
    albums: 'Well-known albums'
  },
  band: {
    creation: 'Creation',
    split: 'Split',
    popularity: 'Popularity',
    fans: 'Fans',
    lineup: 'Line-up',
    formerMembers: 'Former members',
    discography: 'Discography'
  },
  artist: {
    birth: 'Birthday',
    bands: 'Associated band | Associated bands'
  },
  album: {
    type: 'Type',
    studio: 'Studio',
    producer: 'Producer',
    label: 'Label | Labels',
    tracklist: 'Tracklist',
    audio: 'Available audio | Available audios'
  },
  label: {
    releases: 'Latest release | Latest releases'
  },
  place: {
    description: 'Description',
    address: 'Address'
  },
  post: {
    on: 'On',
    by: 'by'
  }
}



// WEBPACK FOOTER //
// ./src/locales/en.js